var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 3,
    fill: "white",
    stroke: "white",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 1.5,
    height: 5,
    rx: 0.5,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.5,
    width: 1.5,
    height: 6.5,
    rx: 0.5,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1.5,
    height: 3,
    rx: 0.5,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5 L22 10.5 A4 4 0 0 0 18 6.5 Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports_icon.0d2c432500af82aab254e876ad56117b.svg";
export { ForwardRef as ReactComponent };